export const invalidEmail = "email is invalid";
export const successMsg = "Thank you for your message. It has been sent.";
